

/**
 * Remove caracteres não numéricos do CNPJ
 * @param {string} cnpj 
 * @returns {string}
 */
export const cleanCNPJ = (cnpj) => {
  return cnpj.replace(/\D/g, '');
};

/**
 * Formata CNPJ para exibição (XX.XXX.XXX/XXXX-XX)
 * @param {string} cnpj 
 * @returns {string}
 */
export const formatCNPJ = (cnpj) => {
  const clean = cleanCNPJ(cnpj);
  return clean.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
};

/**
 * Valida se o CNPJ tem formato correto
 * @param {string} cnpj 
 * @returns {boolean}
 */
export const isValidCNPJ = (cnpj) => {
  const clean = cleanCNPJ(cnpj);
  
  // Verifica se tem 14 dígitos
  if (clean.length !== 14) return false;
  
  // Verifica se não são todos números iguais
  if (/^(\d)\1+$/.test(clean)) return false;
  
  // Validação dos dígitos verificadores
  let sum = 0;
  let weight = 2;
  
  // Primeiro dígito verificador
  for (let i = 11; i >= 0; i--) {
    sum += parseInt(clean.charAt(i)) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }
  
  let remainder = sum % 11;
  let digit1 = remainder < 2 ? 0 : 11 - remainder;
  
  if (digit1 !== parseInt(clean.charAt(12))) return false;
  
  // Segundo dígito verificador
  sum = 0;
  weight = 2;
  
  for (let i = 12; i >= 0; i--) {
    sum += parseInt(clean.charAt(i)) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }
  
  remainder = sum % 11;
  let digit2 = remainder < 2 ? 0 : 11 - remainder;
  
  return digit2 === parseInt(clean.charAt(13));
};

/**
 * Busca informações da empresa via nossa API (que consulta ReceitaWS no backend)
 * @param {string} cnpj 
 * @param {string} token - Token de autenticação
 * @returns {Promise<object|null>}
 */
export const fetchCompanyInfo = async (cnpj, token = null) => {
  const cleanCnpj = cleanCNPJ(cnpj);

  if (!isValidCNPJ(cleanCnpj)) {
    throw new Error('CNPJ inválido');
  }

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  
  const endpoint = token ? '/cnpj/lookup' : '/public/cnpj/lookup';
  
  const headers = {
    'Content-Type': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ cnpj: cleanCnpj })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ detail: 'Erro desconhecido' }));
      throw new Error(errorData.detail || 'Erro ao consultar CNPJ');
    }

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.message || 'CNPJ não encontrado');
    }

    return data;

  } catch (error) {
    console.error('Erro ao buscar informações do CNPJ:', error);
    throw error;
  }
};